/* Pure parser for markdown todo lists (`## Section` + `- [ ]` / `- [x]` items): no React, no fetching. */

export interface ITodoItem {
  section: string
  done: boolean
  /** Item text with markdown links reduced to their labels and backticks dropped */
  text: string
  /** First link in the item, if any */
  link?: { label: string; url: string }
}

const SECTION = /^##\s+(.+?)\s*$/
const ITEM = /^\s*[-*]\s+\[([ xX])\]\s+(.+?)\s*$/
const LINK = /\[([^\]]+)\]\(([^)\s]+)\)/

export const parseTodos = (markdown: string): ITodoItem[] => {
  let section = ""
  const items: ITodoItem[] = []
  for (const line of markdown.split("\n")) {
    const heading = SECTION.exec(line)
    if (heading) {
      section = heading[1]
      continue
    }
    const item = ITEM.exec(line)
    if (!item) continue
    const raw = item[2]
    const link = LINK.exec(raw)
    items.push({
      section,
      done: item[1] !== " ",
      text: raw.replace(new RegExp(LINK.source, "g"), "$1").replace(/`/g, ""),
      link: link ? { label: link[1], url: link[2] } : undefined,
    })
  }
  return items
}
